import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6acfa8bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "App",
  id: "div_app"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { id: "ueberschrift" }, "WBS Rechner", -1))
const _hoisted_3 = { class: "label-container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "personenanzahl" }, "Anzahl Personen im Haushalt", -1))
const _hoisted_5 = { class: "label-container" }
const _hoisted_6 = ["for"]
const _hoisted_7 = ["id", "value"]
const _hoisted_8 = { class: "label-container" }
const _hoisted_9 = ["for"]
const _hoisted_10 = ["id", "onUpdate:modelValue"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: 0,
  disabled: ""
}, "keine Auswahl", -1))
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "label-container" }
const _hoisted_14 = ["for"]
const _hoisted_15 = ["id", "onUpdate:modelValue", "onChange"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: 0,
  disabled: ""
}, "keine Auswahl", -1))
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "label-container" }
const _hoisted_19 = ["for"]
const _hoisted_20 = ["id", "onUpdate:modelValue", "onInput"]
const _hoisted_21 = { class: "label-container" }
const _hoisted_22 = ["for"]
const _hoisted_23 = ["id", "onUpdate:modelValue", "onInput"]
const _hoisted_24 = { class: "label-container" }
const _hoisted_25 = ["for"]
const _hoisted_26 = ["id", "onClick", "title"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Zusammenfassung Haushalt", -1))
const _hoisted_29 = { class: "label-container" }
const _hoisted_30 = ["for"]
const _hoisted_31 = ["id"]
const _hoisted_32 = { class: "label-container" }
const _hoisted_33 = ["for"]
const _hoisted_34 = ["id"]
const _hoisted_35 = { class: "label-container" }
const _hoisted_36 = ["for"]
const _hoisted_37 = ["id"]
const _hoisted_38 = { class: "label-container" }
const _hoisted_39 = ["for"]
const _hoisted_40 = ["id"]
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { class: "label-container" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "yearlyAmount" }, "anrechenbares jährliches Gesamteinkommen:", -1))
const _hoisted_44 = { id: "yearlyAmount" }
const _hoisted_45 = { class: "label-container" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "yearlyAmountMax" }, "Einkommensgrenze:", -1))
const _hoisted_47 = { id: "yearlyAmountMax" }
const _hoisted_48 = { class: "label-container" }
const _hoisted_49 = { for: "difference" }
const _hoisted_50 = { id: "difference" }
const _hoisted_51 = { class: "label-container" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "percent" }, "Verhältnis Gesamteinkommen / Einkommensgrenze", -1))
const _hoisted_53 = { id: "percent" }
const _hoisted_54 = { class: "label-container" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "wbsGranted" }, "Möglicher WBS:", -1))
const _hoisted_56 = { id: "wbsGranted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Headerbox = _resolveComponent("Headerbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_Headerbox, { title: "Haushaltsmitglieder" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.personanzahl) = $event)),
            id: "personenanzahl",
            type: "number",
            min: "1",
            max: "20",
            onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updatePersonenanzahl && _ctx.updatePersonenanzahl(...args)))
          }, null, 544), [
            [_vModelText, _ctx.personanzahl]
          ])
        ])
      ]),
      _: 1
    }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.persons, (person, pindex) => {
      return (_openBlock(), _createElementBlock("div", { key: pindex }, [
        _createVNode(_component_Headerbox, {
          title: 'Daten der ' + person.index + '. Person'
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(person.incomes, (income, inindex) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: inindex,
                  class: "label_box"
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("label", {
                      for: 'number_' + person.index + '_' + inindex
                    }, "Einkommen Nummer", 8, _hoisted_6),
                    _createElementVNode("input", {
                      id: 'amount_' + person.index + '_' + inindex,
                      type: "number",
                      disabled: "",
                      value: inindex+1
                    }, null, 8, _hoisted_7)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("label", {
                      for: 'type_' + person.index + '_' + inindex
                    }, "Typ", 8, _hoisted_9),
                    _withDirectives(_createElementVNode("select", {
                      id: 'type_' + person.index + '_' + inindex,
                      "onUpdate:modelValue": ($event: any) => ((income.type) = $event)
                    }, [
                      _hoisted_11,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.types, (type) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: type.value,
                          value: type.value
                        }, _toDisplayString(type.description), 9, _hoisted_12))
                      }), 128))
                    ], 8, _hoisted_10), [
                      [_vModelSelect, income.type]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("label", {
                      for: 'frequency_' + person.index + '_' + inindex
                    }, "Frequenz", 8, _hoisted_14),
                    _withDirectives(_createElementVNode("select", {
                      id: 'frequency_' + person.index + '_' + inindex,
                      "onUpdate:modelValue": ($event: any) => ((income.frequency) = $event),
                      onChange: ($event: any) => (_ctx.calculateTotalIncome(pindex))
                    }, [
                      _hoisted_16,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.freq, (freq) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: freq.value,
                          value: freq.value
                        }, _toDisplayString(freq.description), 9, _hoisted_17))
                      }), 128))
                    ], 40, _hoisted_15), [
                      [_vModelSelect, income.frequency]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("label", {
                      for: 'amount_' + person.index + '_' + inindex
                    }, "Brutto Betrag", 8, _hoisted_19),
                    _withDirectives(_createElementVNode("input", {
                      id: 'amount_' + person.index + '_' + inindex,
                      type: "number",
                      "onUpdate:modelValue": ($event: any) => ((income.amount) = $event),
                      min: "0",
                      onInput: ($event: any) => (_ctx.calculateTotalIncome(pindex))
                    }, null, 40, _hoisted_20), [
                      [_vModelText, income.amount]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("label", {
                      for: 'advertisingCosts_' + person.index + '_' + inindex
                    }, "jährliche Werbungskosten", 8, _hoisted_22),
                    _withDirectives(_createElementVNode("input", {
                      id: 'advertisingCosts_' + person.index + '_' + inindex,
                      type: "number",
                      "onUpdate:modelValue": ($event: any) => ((income.advertisingCosts) = $event),
                      min: "0",
                      onInput: ($event: any) => (_ctx.calculateTotalIncome(pindex))
                    }, null, 40, _hoisted_23), [
                      [_vModelText, income.advertisingCosts]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("label", {
                      for: 'delete_' + person.index + '_' + inindex
                    }, "Löschen", 8, _hoisted_25),
                    _createElementVNode("button", {
                      class: "delete-button",
                      id: 'delete_' + person.index + '_' + inindex,
                      onClick: ($event: any) => (_ctx.deleteIncome(pindex, inindex)),
                      title: (inindex + 1) + ' Einkommen der ' + person.index + ' Person löschen'
                    }, "× Löschen", 8, _hoisted_26)
                  ])
                ]))
              }), 128)),
              _createElementVNode("button", {
                onClick: ($event: any) => (_ctx.addIncome(person.index)),
                class: "calculateButton"
              }, "+ Einkommen hinzufügen", 8, _hoisted_27)
            ])
          ]),
          _: 2
        }, 1032, ["title"])
      ]))
    }), 128)),
    _createVNode(_component_Headerbox, { title: "WBS berechnen" }, {
      default: _withCtx(() => [
        _hoisted_28,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.persons, (p) => {
          return (_openBlock(), _createElementBlock("div", {
            key: p.index,
            class: "label_box"
          }, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("label", {
                for: 'nr' + p.index
              }, "Nr.", 8, _hoisted_30),
              _createElementVNode("span", {
                id: 'nr' + p.index
              }, _toDisplayString(p.index), 9, _hoisted_31)
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("label", {
                for: 'kindsalter' + p.index
              }, "Kindsalter", 8, _hoisted_33),
              _createElementVNode("span", {
                id: 'kindsalter' + p.index
              }, "N/A", 8, _hoisted_34)
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("label", {
                for: 'freibetrage' + p.index
              }, "Freibeträge", 8, _hoisted_36),
              _createElementVNode("span", {
                id: 'freibetrage' + p.index
              }, "N/A", 8, _hoisted_37)
            ]),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("label", {
                for: 'gesamteinkommen' + p.index
              }, "Gesamteinkommen", 8, _hoisted_39),
              _createElementVNode("span", {
                id: 'gesamteinkommen' + p.index
              }, _toDisplayString(p.totalincome), 9, _hoisted_40)
            ])
          ]))
        }), 128)),
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.calculateWBS && _ctx.calculateWBS(...args))),
          class: "calculateButton"
        }, "⚙ WBS berechnen"),
        (_ctx.wbsResult)
          ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _hoisted_43,
                _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.wbs.yearlyAmount) + " €", 1)
              ]),
              _createElementVNode("div", _hoisted_45, [
                _hoisted_46,
                _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.wbs.yearlyAmountMax) + " €", 1)
              ]),
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("label", _hoisted_49, _toDisplayString(_ctx.wbs.difference > 0 ? 'Überschreitung' : 'Unterschreitung'), 1),
                _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.wbs.difference) + " €", 1)
              ]),
              _createElementVNode("div", _hoisted_51, [
                _hoisted_52,
                _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.wbs.percent) + " %", 1)
              ]),
              _createElementVNode("div", _hoisted_54, [
                _hoisted_55,
                _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.wbs.wbsGranted), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}